module.exports = __webpack_public_path__ + "static/media/chevron-up.379d3781.svg";